// Site-wide links and shared copy.

export const BOOKING_URL = "https://cal.read.ai/rakhveer-mao1p/30-min";
export const CONTACT_EMAIL = "rakhveer@rakisolutions.com";
export const CONTACT_PHONE = "+65 9422 3035";
export const WHATSAPP_NUMBER = "6594223035";
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}`;
export const LINKEDIN_URL = "https://www.linkedin.com/company/rakisolutions";

export const CTA_LABEL = "Book a free sales audit";
